import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  public encryptString(text: string): string {
    // For UTF-8 support, convert to bytes first
    const bytes: Uint8Array = new TextEncoder().encode(text);
    const binString: string = Array.from(bytes, (byte: number) => String.fromCodePoint(byte)).join('');
    return btoa(binString);
  }

  // Base64 decoding (modern approach)
  /** Returns '' for a malformed id (e.g. a truncated deep link) instead of throwing from `atob`. */
  public decryptUsingAES256(encodedText: string): string {
    try {
      const binString: string = atob(encodedText);
      const bytes: Uint8Array = Uint8Array.from(binString, (m: string) => m.codePointAt(0)!);
      return new TextDecoder().decode(bytes);
    } catch {
      return '';
    }
  }

  // SHA-256 hashing (Web Crypto API)
  public async hashSHA256(text: string): Promise<string> {
    const encoder: TextEncoder = new TextEncoder();
    const data: BufferSource = encoder.encode(text);
    const hashBuffer: ArrayBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray: number[] = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b: number) => b.toString(16).padStart(2, '0')).join('');
  }
}
